import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';

const DEFAULT_COLOR = 'rgba(0, 0, 0, 0)';

@Component({
  selector: 'ag-shr-color-sketch-input',
  templateUrl: './color-sketch-input.component.html',
  styleUrl: './color-sketch-input.component.scss',
})
export class ColorSketchInputComponent {
  @HostBinding('class') className = 'color-sketch-input';

  @Input() value: string | undefined = DEFAULT_COLOR;
  @Output() valueChange = new EventEmitter<string>();
  @Input() label: string;
  @Input() readOnly = false;

  @Input() presetColors;

  protected handleValueChange = (color: string) => {
    this.value = color;

    this.valueChange.emit(color);
  };
}
